module.exports = __webpack_public_path__ + "static/Shiftgig-55c63efc7830504b4d18847373ffdd56.jpg";